import React, { useState, useContext } from 'react';
import { styled, alpha } from '@mui/material/styles';
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Container,
  Drawer,
  MenuItem,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkMode';
import LightModeOutlinedIcon from '@mui/icons-material/LightMode';
import { Link } from 'react-router-dom';
import { ColorModeContext} from '../theme'; // Import theme context
import { useTheme } from '@mui/material';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

function NavBarBar() {
  const [open, setOpen] = useState(false);
  const theme = useTheme(); // ✅ Get current theme mode
  // const colours = tokens(theme.palette.mode)
  const colorMode = useContext(ColorModeContext);


  const logoimg = theme.palette.mode === "dark" ? "/images/SJ_SWIMMING_White_Red.png" :"/images/SJ_SWIMMING_Navy.png";

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };


  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          {/* Logo Section */}
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            <Link to="/">
              <img src={logoimg} alt="SJ Logo" style={{ height: '40px', width: 'auto' }} />
            </Link>
          </Box>

          {/* Desktop Navigation */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
            <Button color="primary" component={Link} to="/about-us">About Us</Button>
            <Button color="primary" component={Link} to="/locations">Locations</Button>
            <Button color="primary" component={Link} to="/programs">Programs</Button>
            <Button color="primary" component={Link} to="/policies">Policies</Button>
            <Button color="primary" component={Link} to="/gallery">Gallery</Button>
            <Button color="primary" component={Link} to="/contact-us">Contact Us</Button>
          </Box>

          {/* Light/Dark Mode Toggle Button */}
          <IconButton
            sx={{ ml: 2 }}
            onClick={colorMode.toggleColorMode}
          >
            {theme.palette.mode === 'dark' ? (
              <DarkModeOutlinedIcon />
            ) : (
              <LightModeOutlinedIcon />
            )}
          </IconButton>

          {/* Mobile Navigation */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{
                sx: { top: 'var(--template-frame-height, 0px)' },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                <MenuItem component={Link} to="/about-us" onClick={toggleDrawer(false)}>About Us</MenuItem>
                <MenuItem component={Link} to="/locations" onClick={toggleDrawer(false)}>Locations</MenuItem>
                <MenuItem component={Link} to="/programs" onClick={toggleDrawer(false)}>Programs</MenuItem>
                <MenuItem component={Link} to="/policies" onClick={toggleDrawer(false)}>Policies</MenuItem>
                <MenuItem component={Link} to="/gallery" onClick={toggleDrawer(false)}>Gallery</MenuItem>
                <MenuItem component={Link} to="/contact-us" onClick={toggleDrawer(false)}>Contact Us</MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}

export default NavBarBar;